import { useTranslation } from "react-i18next"

export function ResultCommvPage({ goToIntroPage }: { goToIntroPage: () => void }) {
  const { t } = useTranslation(["keuzewijzer", "common"])

  return (
    <div>
      <h1>{t("service__commv_name", { ns: "common" })} 🎈</h1>
      <h2>{t("service__commv_description", { ns: "common" })}</h2>
      <p>{t("service__commv_slug", { ns: "common" })}</p>
      <div className="wrapper-row">
        <button className="button-primary" onClick={() => window.open(process.env.REACT_APP_GLIDE_URL)}>{t("button__finish", { ns: "common" })}</button>
        <button className="button-secondary">{t("button__info", { ns: "common" })}</button>
        <button className="button-void" onClick={goToIntroPage}>{t("button__retry", { ns: "common" })}</button>
      </div>
    </div>
  )
}